// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "mapbox-gl" + "." + "65d14fddf68f6e576138" + ".js";
};